// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"i3-z","displaySixCardTiles":"j3-z"};